import Entity from "./entity";
import Description from "./description";
import Item from "./item";

class Armor {
  static make(glyph, name, description, bonus, quality) {
    return new Entity(null, null, glyph, name, {
      description: new Description(description),
      item: new Item(quality),
      armor: new Armor(bonus)
    });
  }

  constructor(bonus) {
    this.bonus = bonus;
  }
}

export default Armor;
